class HeaderMenu extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector(".header__inline-menu > ul");
        this.itemsDetails = this.querySelectorAll("[data-items-menu] details");
        this.overlay = document.querySelector(".header-menu__overlay-element");
        this.dropdownInnerItemImages = this.querySelectorAll(
            ".dropdown-inner > [data-item-image-index]"
        );

        /* remove dropdown menu links if config option is checked */
        this.dropdownInnerItemImages ? this.removeDropdownMenuLinks() : null;

        /* dropdown-inner
         * - remove redundant item images. Show only one Item-Image per Dropdown Inner
         * - set max-height. Show items menu that do not fit the dropdown height on scroll
         */
        const dropdownInner = this.querySelectorAll(
            ".dropdown-inner.full-width"
        );
        if (this.container && dropdownInner) {
            /* show only one image per dropdown item */
            // this.removeOddItemImages(dropdownInner);

            /* set dropdown inner max-height */
            this.setMaxHeight(dropdownInner);

            /* set dropdown inner items width */
            this.dropdownItemsWidth(dropdownInner);
        }

        this.querySelectorAll("details-disclosure > details").forEach(
            (detail) => {
                if (this.container.dataset?.activateMenu == "on_click") {
                    // activate top level items on hover
                    detail.addEventListener(
                        "click",
                        this.activateTopLevelOnClick.bind(this)
                    );
                } else {
                    // activate top level items on hover - default behavior
                    detail.addEventListener(
                        "mousestop",
                        this.activateTopLevelOnHover.bind(this)
                    );
                    detail.addEventListener(
                        "mouseleave",
                        this.mouseLeave.bind(this)
                    );
                }

                // highlight top level items when its child active
                this.highlightParentItemOnActiveChild(detail);
            }
        );

        // remove overlay on click - useful with behavior activate to level on click
        this.overlay.addEventListener("click", (e) => {
            e.preventDefault();
            this.removeOverlay();
        });

        if (!this.itemsDetails.length) return;

        // megamenu - open dropdown inner always
        this.itemsDetails.forEach((detail) => {
            if (detail.lastElementChild.dataset.typeMenu == "full-width")
                detail.setAttribute("open", true);
        });
    }

    updatePositionThirdLevelMenu(detail) {
        let dropdownInner = detail.children[1];
        if (!dropdownInner?.classList.contains("small")) return;

        let menuDisclosure = dropdownInner.querySelectorAll(
            ".childlist-menu--disclosure"
        );

        menuDisclosure.forEach((childlist) => {
            const elX = childlist.getBoundingClientRect().x;
            const elWidth = childlist.getBoundingClientRect().width;

            if (elX + elWidth > this.container.offsetWidth)
                childlist.setAttribute("data-menu-position", "updated");
        });
    }

    activateTopLevelOnClick(e) {
        let detail = e.target.closest("details"),
            summary = e.target.closest("summary"),
            topLevelItems = this.container.querySelectorAll(
                "details-disclosure > details > summary > a"
            );

        // remove active class from all items
        topLevelItems.forEach((item) => {
            item.classList.remove("list-menu__item--active");
        });

        // set dynamically position to navigation width of childlist-menu--disclosure list (third-level)
        this.updatePositionThirdLevelMenu(detail);

        if (
            detail.parentElement.nodeName === "DETAILS-DISCLOSURE" &&
            e.target.nodeName !== "A"
        ) {
            e.preventDefault();
            e.stopPropagation();
            detail.setAttribute("open", true);

            /* show overlay only for Department item menu - small type */
            if (detail.parentElement.parentElement.dataset.mainItemMenu)
                this.showOverlay();

            // highlight the active menu item
            summary?.children[0].classList.add("list-menu__item--active");
        }
    }

    activateTopLevelOnHover(e) {
        let detail = e.target.closest("details");

        /* first item of small menu uses separate event */
        if (detail.parentElement.parentElement.dataset.mainItemMenu) {
            this.container.style.overflow = "visible";
            this.mouseOver(detail);
            return;
        }

        // set dynamically position to navigation width of childlist-menu--disclosure list (third-level)
        this.updatePositionThirdLevelMenu(detail);

        detail.setAttribute("open", true);

        // diactivate on Item leave
        if (detail.closest(".full-width") == null)
            detail.addEventListener("mouseleave", this.mouseLeave.bind(this));
    }

    showOverlay() {
        if (this.overlay.style.display == "")
            this.overlay.style.display = "block";

        if (!this.overlay.classList.contains("shown"))
            setTimeout(() => {
                this.overlay.classList.add("shown");
            }, 100);
    }

    removeOverlay() {
        this.overlay.classList.remove("shown");
        setTimeout(() => {
            this.overlay.style.display = "";
        }, 200);
    }

    getSubMenuHeight(submenu) {
        this.subMenuHeight =
            submenu.getBoundingClientRect().bottom -
            submenu.getBoundingClientRect().top;
        return this.subMenuHeight;
    }

    setMinHeight(detail) {
        let childListsMenu = detail.querySelectorAll(
            ".childlist-menu--disclosure"
        );

        /* set childlist height as submenu height */
        if (
            !childListsMenu.length ||
            !detail.parentElement.parentElement.dataset.mainItemMenu
        )
            return;

        childListsMenu.forEach((childList) => {
            childList.style.minHeight = this.subMenuHeight
                ? `${this.subMenuHeight}px`
                : `${this.getSubMenuHeight(detail.querySelector("ul"))}px`;
        });
    }

    mouseOver(detail) {
        detail.querySelectorAll("details").forEach((childDetail) => {
            /* show overlay only for main (first) small item menu */
            if (detail.parentElement.parentElement.dataset.mainItemMenu)
                this.showOverlay();

            childDetail.addEventListener("mouseover", (evt) => {
                this.mouseOver(childDetail);
            });
            childDetail.addEventListener(
                "mouseleave",
                this.mouseChildLeave.bind(this)
            );
        });

        detail.setAttribute("open", true);
        this.setMinHeight(detail);
    }

    mouseLeave(event) {
        let detail = event.target;

        this.subMenuHeight = false;
        detail.removeAttribute("open");
        if (
            detail.parentNode.closest("li").hasAttribute("data-main-item-menu")
        ) {
            this.removeOverlay();
        }
    }

    mouseChildLeave(event) {
        /* first item of small menu */
        this.subMenuHeight = false;
        if (event.target.hasAttribute("open")) {
            setTimeout(() => {
                event.target.removeAttribute("open");
            }, 200);
        }
    }

    dropdownItemsWidth(dropdownInner) {
        dropdownInner.forEach((grid) => {
            let containerGrid = grid.querySelector(".container--grid"),
                containerGridItems = containerGrid.children;

            if (containerGridItems.length < 2) {
                return;
            } else if (containerGridItems.length === 2) {
                [...containerGridItems].forEach((item, index) => {
                    if (index === 1)
                        item.style.width =
                            100 / containerGridItems.length + "%";
                });
            } else {
                [...containerGridItems].forEach((item, index) => {
                    item.style.width = 100 / containerGridItems.length + "%";
                });
            }
        });
    }

    removeDropdownMenuLinks() {
        const dropdownGrid = this.querySelectorAll(".container--grid");

        this.dropdownInnerItemImages.forEach((item) => {
            dropdownGrid?.forEach((dropdown) => {
                if (
                    dropdown.children[0].dataset.itemIndex ===
                    item.dataset.itemImageIndex
                )
                    dropdown.children[0].remove();
            });
        });
    }

    removeOddItemImages(dropdownInner) {
        dropdownInner.forEach((item) => {
            let el = item.children[0];
            if (el && el.childNodes.length > 2) {
                let childs = el.children;
                for (var i in childs) {
                    if (i > 1 && childs[i])
                        childs[i].classList.add("odd-image-item");
                }
            }
            /* use extra class to update dropdown width with item-image */
            if (el && el.children[1]) {
                el.classList.add("inner--with-image");
            }
        });

        document.querySelectorAll(".odd-image-item").forEach((item) => {
            item.remove();
        });
    }

    setMaxHeight(dropdown) {
        let inner_height = window.innerHeight,
            inner_width = window.innerWidth;

        if (inner_width < 980) return;

        let headerSectionHeight = document.querySelectorAll(
                ".shopify-section-group-header-group"
            ),
            sum = 0;

        headerSectionHeight?.forEach((el) => {
            if (el.id.indexOf("_header") > 0) sum += el.offsetHeight; // get all header top sections height
        });

        dropdown.forEach((item) => {
            let innerHeightWithNoHeaderHeight = inner_height - sum;
            // fix for Firefox and Safari browsers
            // set dropdown inner max height
            item.style.maxHeight = innerHeightWithNoHeaderHeight + "px";
            item.style.overflowX = "auto";
        });
    }

    highlightParentItemOnActiveChild(detail) {
        /* Highlight the first menu item permanently enabled */
        if (this.container.children[0].dataset.linkHighlighted == "true")
            return;

        let dropdownInner = detail.children[1],
            activeChild = dropdownInner.querySelector(
                ".list-menu__item--active"
            );

        if (activeChild)
            detail.parentElement.parentElement.classList.add(
                "highlite_parent_item_on_active_child"
            );
        else
            detail.parentElement.parentElement.classList.remove(
                "highlite_parent_item_on_active_child"
            );
    }
}

customElements.define("header-menu", HeaderMenu);

/* create custom event for better behavior on top level mouseover */
(function (mouseStopDelay) {
    var timeout;
    document.addEventListener("mouseover", function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            var event = new CustomEvent("mousestop", {
                detail: {
                    clientX: e.clientX,
                    clientY: e.clientY,
                },
                bubbles: true,
                cancelable: true,
            });
            e.target.dispatchEvent(event);
        }, mouseStopDelay);
    });
})(150);
